import { Field } from 'react-final-form';

import { Text } from '@change/ds-core-ui';

import { RichTextEditor } from 'src/app/shared/components/richTextEditor';
import { requiredValidatorWithNoMessage } from 'src/app/shared/form/validators';

import type { DescriptionTextAreaProps, PetitionUpdateFormValues } from '../../types';

import { EmbeddedMediaPreview } from './components/EmbeddedMediaPreview';
import { useDescriptionTextArea } from './hooks/useDescriptionTextArea';

export function DescriptionTextArea({ initialValue }: DescriptionTextAreaProps) {
	const {
		actions: { onDescriptionChange, trackFocus, onClosePreview, onFetchError, onFetchSuccess },
		data: { description, descriptiveLabel, label },
	} = useDescriptionTextArea();

	return (
		<div className="w-full">
			<Field<PetitionUpdateFormValues['description']>
				name="description"
				type="text"
				initialValue={initialValue}
				validate={requiredValidatorWithNoMessage}
			>
				{({ input: { onChange } }) => {
					return (
						<div className="flex flex-col gap-4">
							<Text as="label" htmlFor="petition-update-text-editor" variant="heading" size="x-small">
								{label}
							</Text>
							<RichTextEditor
								data-testid="description"
								textEditorId="petition-update-text-editor"
								initialValue={initialValue}
								hideLabel
								descriptiveLabel={descriptiveLabel}
								customEditorConfig={{
									height: 232,
									min_height: 232,
								}}
								onEditorChange={(descriptionInput) => onDescriptionChange(descriptionInput, onChange)}
								onEditorFocus={() => trackFocus()}
							/>
						</div>
					);
				}}
			</Field>
			<EmbeddedMediaPreview
				value={description}
				onClosePreview={onClosePreview}
				onFetchError={onFetchError}
				onFetchSuccess={onFetchSuccess}
			/>
		</div>
	);
}
